export default "__VITE_ASSET__Dm$b2KoW__"